function imageResizeProductThumbnail(){jQuery(window).width()>999&&jQuery(".product__thumbnail-list").css("max-height",jQuery(".product__media-list-wrapper").height()+"px")}jQuery(document).ready(function(e){e(".accordion-item-header").click(function(){e(this).parent(".accordion-item").toggleClass("open")});var i=e(".experts-slider");i.owlCarousel({items:3,margin:20,loop:!1,nav:!1,dots:!1,responsive:{0:{items:1,stagePadding:50,margin:20},768:{items:2},1e3:{items:2},1025:{items:3}}});var i=e(".project-slider");i.owlCarousel({loop:!0,margin:10,nav:!0,dot:!0,items:1,responsive:{0:{items:1},767:{items:1},1e3:{items:1}}}),e(".brand_slider").owlCarousel({loop:!1,margin:10,nav:!1,responsive:{0:{items:2},600:{items:4},1e3:{items:6}}}),e("#guideline-items").owlCarousel({loop:!1,margin:10,nav:!0,dots:!1,autoHeight:!0,responsive:{0:{items:1},600:{items:1}}}),e(".logo_slider").owlCarousel({items:6,loop:!0,margin:30,nav:!1,dots:!1,autoplay:!0,slideTransition:"linear",autoplayTimeout:5e3,autoplaySpeed:5e3,autoplayHoverPause:!1,responsive:{0:{items:2,margin:10,autoplayTimeout:3e3,autoplaySpeed:3e3},600:{items:3,loop:!0,autoplayTimeout:3e3,autoplaySpeed:3e3},1e3:{items:6}}}),jQuery(".point-element").mouseover(function(){jQuery(".desc-block").hide(),jQuery(".desc-block",this).css("display","flex")}),e(".line-item__remove").on("click",function(i){i.prevenDefault();var t=e(".header__cart-count").html(),o=parseInt(t,10)-1;e(".header__cart-count").html(o)}),jQuery("#main .drawer.drawer--large.hidden-phone").detach().insertAfter("#shopify-section-mini-cart"),jQuery(".product__thumbnail-list").length>0&&imageResizeProductThumbnail(),"de"==Shopify.locale?jQuery("#notify").text("Benachrichtigen, wenn wieder verf\xfcgbar"):"en"==Shopify.locale?jQuery("#notify").text("Notify me when available"):"fr"==Shopify.locale?jQuery("#notify").text("Pr\xe9venez-moi d\xe8s qu'il sera \xe0 nouveau disponible"):"es"==Shopify.locale&&jQuery("#notify").text("Informu min kiam disponeblas denove")}),$(".project-slider").on("initialized.owl.carousel changed.owl.carousel",function(e){if(e.namespace){var i=e.relatedTarget;$(".slider-counter").text(i.relative(i.current())+1+"/"+i.items().length)}}).owlCarousel({items:1,autoHeight:!0,loop:!1,margin:0,nav:!0,navText:["Prev","Next"],navContainer:".project-section .custom-nav",dots:!1}),jQuery(window).resize(function(){jQuery(".product__thumbnail-list").length>0&&imageResizeProductThumbnail()});

// PDP Badges - hide on scroll past first image
document.addEventListener('DOMContentLoaded', function() {
  if (!document.querySelector('.product-page')) return;

  setInterval(function() {
    var selected = document.querySelector('.product__media-item.is-selected');
    if (!selected) return;
    var pos = parseInt(selected.getAttribute('data-original-position') || '0');
    document.querySelectorAll('.product-media-main-wrapper .label--custom').forEach(function(b) {
      b.style.transition = 'opacity 0.3s ease';
      b.style.opacity = pos === 0 ? '1' : '0';
    });
  }, 200);
});
/* Reduziert-Badge dynamisch mit gewählter Variante synchronisieren */
(function () {
  function initSaleBadgeSync() {
    var wrapper = document.querySelector('.product-media-main-wrapper');
    var media = document.querySelector('product-media[product-handle]');
    if (!wrapper || !media) return;

    var handle = media.getAttribute('product-handle');
    var productPromise = fetch('/products/' + handle + '.js').then(function (r) { return r.json(); });

    function sync() {
      productPromise.then(function (product) {
        var input = document.querySelector('.product-form input[name="id"], .product-form select[name="id"]');
        if (!input) return;
        var v = product.variants.filter(function (x) { return String(x.id) === String(input.value); })[0];
        if (!v) return;
        var badge = wrapper.querySelector('.label--custom.sale');
        var onSale = v.compare_at_price && v.compare_at_price > v.price;
        if (onSale && !badge) {
          badge = document.createElement('span');
          badge.className = 'label label--custom sale';
          badge.textContent = 'Reduziert';
          wrapper.prepend(badge);
        } else if (!onSale && badge) {
          badge.remove();
        }
      });
    }

    document.addEventListener('change', function (e) {
      if (e.target.closest && e.target.closest('.product-form, product-variants')) {
        setTimeout(sync, 50);
      }
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initSaleBadgeSync);
  } else {
    initSaleBadgeSync();
  }
})();